<template>
  <NuxtLoadingIndicator />
  <NuxtLayout></NuxtLayout>
</template>
